// @flow
import React from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import styles from './styles.module.scss';
import Button from '../Button';
import Arrow from '../Arrow/Arrow';
import { P } from '../Typography';

type Props = {
  onClick: (number) => void,
  currentActiveTable: number,
  className?: string,
  stake: string,
  cards: string,
  ts: string,
  isDoublesuit: boolean,
  setSuit: (string) => void,
  selectedStakeIsRfi?: boolean,
  easyRFI?: boolean,
  isPlo5: boolean,
  ggps?: string,
  setShowPercents?: () => void,
  setPercents?: () => void,
}

const BreadCrumbs = ({
  onClick,
  currentActiveTable,
  className,
  stake,
  cards,
  ts,
  isDoublesuit,
  setSuit,
  selectedStakeIsRfi,
  easyRFI,
  isPlo5,
  ggps,
  setShowPercents,
  setPercents,
}: Props) => {
  const dispatch = useDispatch();
  // const addVsSqz = () => {
  //   const isSqz = /\d/g.test(stake);
  //   return isSqz ? `${stake} vs sqz` : stake;
  // };

  const handleTS = () => {
    if (ggps === 'ps' && ts === 'high' && !isPlo5) return 'Medium+';
    if (ts === 'high_plus') return 'High';
    if (ts === 'low') return 'Low';
    if (ts === 'medium') return 'Medium';
    if (ts === 'high') return 'High';
    if (ts === 'mttpot') return 'MTT POT';
    if (ts === 'mtt2_25x') return 'MTT 2.25';
    if (ts === 'mttpot_ante') return 'MTT ANTE POT';
    if (ts === 'mttx25_ante') return 'MTT ANTE 2.5';
    if (ts === 'hu') return 'HEADS UP';
    if (ts === 'ante') return 'ANTE';
    if (ts === 'ante3_5x') return 'ANTE 3.5x';
    if (ts === 'straddle') return 'Straddle';
    if (ts === 'straddle3x') return 'Straddle 3x';
    return '';
  };

  const handleLabel = () => {
    const label = `${stake.slice(0, 2).toUpperCase()}${stake.slice(2).toUpperCase()
      .replace('VS', ' vs ')
      .replace('VS', 'vs')
      .replace('RFI', ' RFI')
      .replace('BB', ' bb ')
      .replace('NO', ' no ')
      .replace('SQZ', ' sqz ')
      .replace(' bb', 'BB ')}`;
    if (selectedStakeIsRfi && easyRFI && isPlo5) {
      return `Easy ${label} RFI`;
    }
    if (selectedStakeIsRfi && easyRFI) {
      return `Easy ${label}`;
    }
    return label;
  };

  const breadCrumbData = [
    { table: 1, label: handleTS() },
    {
      table: 2,
      label: handleLabel(),
    },
    { table: 3, label: cards },
  ];
  const plo5BreadCrumbData = [
    { table: 1, label: handleTS() },
    {
      table: 2,
      label: handleLabel(),
    },
    { table: 3, label: cards.slice(0, 2) },
    { table: 4, label: cards.slice(2, 4) },
  ];

  // eslint-disable-next-line max-len
  const actualBreadCrumbData = isPlo5 ? plo5BreadCrumbData.slice(0, currentActiveTable) : breadCrumbData.slice(0, currentActiveTable);
  const percentsHandler = (index) => {
    if (index === 1) {
      setShowPercents(true);
    }
    if (index === 0) {
      setPercents('');
      setShowPercents(true);
    }
  };

  const DsSsLabel = () => (
    <P className={classnames(
      styles.breadcrumbText,
      { [styles.DS]: isDoublesuit },
      { [styles.SS]: !isDoublesuit },
    )}
    >
      {isDoublesuit ? 'ds' : 'ss'}
    </P>
  );

  const handleDsSs = () => {
    if (isPlo5 && currentActiveTable === 3) {
      return DsSsLabel();
    }

    if (!isPlo5 && currentActiveTable === 4) {
      return DsSsLabel();
    }

    return '';
  };

  const handleClick = (item, index) => {
    if (!isPlo5 && currentActiveTable === 4 && index === 2) {
      return;
    }
    onClick(item.table);
    percentsHandler(index);
    dispatch(setSuit(isDoublesuit ? 'double' : 'single'));
  };

  return (
    <span
      className={classnames(styles.breadcrumbContainer, className)}
    >
      {actualBreadCrumbData.map((item, index, array) => (
        [
          <Button
            transparent
            small
            key={item.table}
            onClick={() => { handleClick(item, index); }}
          >
            <P className={styles.breadcrumbText}>{item.label}</P>
          </Button>,
          (array[index + 1]) ? <Arrow key={item.label} /> : '']
      ))}
      {handleDsSs()}
    </span>
  );
};

export default BreadCrumbs;
